import {
  Component,
  ComponentFactoryResolver,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { Router } from '@angular/router';
import { StringHelper } from 'src/app/helpers/string-helper';
import { Project } from 'src/app/model/project/project';
import { SubProjectControllerRequestService } from 'src/app/services/api/sub-project-controller-request.service';
import { ClientProjectDetailTab } from './tab-manager/client-project-detail-tab';
import { ClientProjectDetailTabManager } from './tab-manager/client-project-detail-tab-manager';
import { AtelierRecupEventService } from 'src/app/services/atelier/atelier-recup-event-service';

@Component({
  selector: 'client-project-detail',
  templateUrl: './client-project-detail.component.html',
  styleUrls: ['./client-project-detail.component.scss']
})
export class ClientProjectDetailComponent implements OnInit, OnDestroy {
  @Input()
  project: Project;

  @Input()
  subProjectId: number;

  @Input()
  type: string;

  @Input()
  priorityType: string;

  @Input()
  form = false;

  @Input()
  title: string;

  @Input()
  forAtelier: boolean = false;

  @ViewChild('projectDetailTabContent', {
    read: ViewContainerRef,
    static: true
  })
  projectDetailTabContent: ViewContainerRef;

  init: boolean = false;

  tabManager: ClientProjectDetailTabManager;

  constructor(
    private subProjectControllerRequestService: SubProjectControllerRequestService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private atelierRecupEventService: AtelierRecupEventService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.tabManager = new ClientProjectDetailTabManager(
      this.componentFactoryResolver,
      this.projectDetailTabContent
    );
    this.prepareSubProjectTabs();

    this.projectDetailTabContent;
  }

  ngOnDestroy(): void {
    this.tabManager.destroy();
  }

  onTabActivation(): void {}

  onTabDeactivation(): void {}

  private async prepareSubProjectTabs(): Promise<void> {
    const nonArchivedSubProjects = await this.subProjectControllerRequestService.getNonArchivedSubProjects(
      this.project.id
    );
    this.tabManager.prepareSubProjectTabs(
      this.project.id,
      nonArchivedSubProjects,
      this.type,
      this.title,
      this.form,
      this.forAtelier
    );

    this.init = true;

    let typeToOpen = this.type;
    let subProjectId = this.subProjectId;

    if (!StringHelper.isEmpty(this.priorityType)) {
      let matchingIdSubProject = null;
      let priorityTypeSubProject = null;
      for (const subProject of nonArchivedSubProjects) {
        if (subProject.type === this.priorityType) {
          if (priorityTypeSubProject == null) {
            priorityTypeSubProject = subProject;
          }
          if (
            subProject.id === this.subProjectId &&
            matchingIdSubProject == null
          ) {
            matchingIdSubProject = subProject;
            break;
          }
        }
      }
      if (priorityTypeSubProject != null && matchingIdSubProject == null) {
        typeToOpen = this.priorityType;
        subProjectId = priorityTypeSubProject.id;
      }
    }
    this.tabManager.activateTabMatching(subProjectId, typeToOpen, this.form);
  }

  openTab(tab: ClientProjectDetailTab): void {
    this.tabManager.activateTab(tab);
  }

  closeTab() {
    if (this.forAtelier) {
      this.atelierRecupEventService.getRecupDetailCloseSubject().next();
    }
    this.router.navigateByUrl('/atelier-recup');
  }
}
